import _ from 'lodash';

function VehicleIncident(_claim, _puwClaimExtension, _vehicleIncident) {
    Object.defineProperty(this, '_claim', {
        enumerable: false,
        value: _claim
    });

    Object.defineProperty(this, '_puwClaimExtension', {
        enumerable: false,
        value: _puwClaimExtension
    });

    if (_vehicleIncident) {
        _.extend(this, _vehicleIncident);
    } else {
        this.vehicle = null;
    }
}


VehicleIncident.prototype.availableVehicles = function () {
    return this._puwClaimExtension.availableVehicles(this.vehicle);
};

VehicleIncident.prototype.setNewVehicle = function () {
    this.vehicle = this._puwClaimExtension.createVehicle();
};

export default VehicleIncident;
